import { z } from "zod";
import {
  createCreateOneRequestSchema,
  createDeleteOneRequestSchema,
  createGetListRequestSchema,
  createUpdateManyRequestSchema,
  createUpdateOneRequestSchema,
  DomainModelMetaSchema,
  DomainModelSchema,
  IdentifierSchema,
} from "../util/index.ts";

export const ReportingGroupSchema = z
  .object({
    /** the name of this reporting group */
    name: z.string(),
    /** description of the purpose of this reporting group */
    description: z.string(),
    /** order to show this reporting group in */
    priority: z.number().nonnegative(),
    /** under what company account is this reporting group under? */
    company_id: IdentifierSchema,
  })
  .merge(DomainModelSchema)
  .merge(DomainModelMetaSchema)
  .describe(
    "Represents a Reporting Group or Reporting Scenario in the Node API"
  );
export type ReportingGroupType = z.infer<typeof ReportingGroupSchema>;

export const ReportingGroupGetListRequestSchema = createGetListRequestSchema(
  ReportingGroupSchema.pick({
    id: true,
    name: true,
  })
);
export type ReportingGroupGetListRequestType = z.infer<
  typeof ReportingGroupGetListRequestSchema
>;

export const ReportingGroupCreateOneRequestSchema =
  createCreateOneRequestSchema(
    ReportingGroupSchema.pick({
      id: true,
      name: true,
      description: true,
      priority: true,
    })
  );
export type ReportingGroupCreateOneRequestType = z.infer<
  typeof ReportingGroupCreateOneRequestSchema
>;

export const ReportingGroupUpdateOneRequestSchema =
  createUpdateOneRequestSchema(
    ReportingGroupSchema.pick({
      id: true,
      name: true,
      description: true,
      priority: true,
    }).partial()
  );
export type ReportingGroupUpdateOneRequestType = z.infer<
  typeof ReportingGroupUpdateOneRequestSchema
>;

export const ReportingGroupEstimationMethodSchema = z
  .object({
    groupId: IdentifierSchema,
    estimationMethodId: IdentifierSchema,
  })
  .describe(
    "Represents a Reporting Group or Reporting Scenario tied to an Estimation Method in the Node API"
  );
export type ReportingGroupEstimationMethodType = z.infer<
  typeof ReportingGroupEstimationMethodSchema
>;

export const ReportingGroupEstimationMethodCreateOneRequestSchema =
  createCreateOneRequestSchema(
    ReportingGroupEstimationMethodSchema.pick({
      estimationMethodId: true,
    }),
    z.object({
      reportingGroupId: IdentifierSchema,
    })
  );
export type ReportingGroupEstimationMethodCreateOneRequestType = z.infer<
  typeof ReportingGroupEstimationMethodCreateOneRequestSchema
>;

export const ReportingGroupEstimationMethodDeleteOneRequestSchema =
  createDeleteOneRequestSchema(
    ReportingGroupEstimationMethodSchema,
    z.object({
      reportingGroupId: IdentifierSchema,
    })
  );
export type ReportingGroupEstimationMethodDeleteOneRequestType = z.infer<
  typeof ReportingGroupEstimationMethodDeleteOneRequestSchema
>;

export const ReportingGroupEstimationMethodUpdateManyRequestSchema =
  createUpdateManyRequestSchema(
    ReportingGroupEstimationMethodSchema.pick({ estimationMethodId: true }),
    z.object({
      currentReportingGroups: z.array(
        ReportingGroupCreateOneRequestSchema.shape.data
      ),
    })
  );
export type ReportingGroupEstimationMethodUpdateManyRequestType = z.infer<
  typeof ReportingGroupEstimationMethodUpdateManyRequestSchema
>;
